function scrollToKontakt() {
	const el = Array.from(document.querySelectorAll('section, div, p')).find(x => x.textContent.toLowerCase().includes('kontakt'))
	if (el) el.scrollIntoView({behavior:'smooth', block:'start'})
}

document.addEventListener('click', e => {
	const a = e.target.closest('a')
	if (!a) return
	if (!a.textContent.toLowerCase().includes('kontakt')) return
	e.preventDefault()
	scrollToKontakt()
	location.hash = 'kontakt'
})

if (location.hash === '#kontakt') scrollToKontakt()